import type { MisconceptionDefinition } from '../types';
export const STU_OPZOEKEN_MISCONCEPTIONS: MisconceptionDefinition[] = [
// ───────────────────────────────────────────────────────────
// STU-ALFABET — alfabetische volgorde
// ───────────────────────────────────────────────────────────
{
  id: 'stu.alfabet-b-voor-a',
  label: 'Denkt dat B vóór A komt',
  module: 'Studievaardig',
  description: 'Leerling beheerst de alfabetvolgorde nog niet en plaatst B vóór A, of kiest een random volgorde.',
  typicalFamilies: ['STU-ALFABET']
}, {
  id: 'stu.alfabet-subjectieve-volgorde',
  label: 'Subjectieve volgorde i.p.v. alfabet',
  module: 'Studievaardig',
  description: 'Leerling rangschikt woorden op persoonlijke voorkeur (favoriet, eerste-gezien) i.p.v. de alfabetische conventie.',
  typicalFamilies: ['STU-ALFABET']
}, {
  id: 'stu.alfabet-volgorde-optioneel',
  label: 'Volgorde optioneel geacht',
  module: 'Studievaardig',
  description: 'Leerling denkt dat alfabetisch ordenen optioneel is en plaatst woorden willekeurig.',
  typicalFamilies: ['STU-ALFABET']
}, {
  id: 'stu.alfabet-range-te-breed',
  label: 'Range te breed gekozen',
  module: 'Studievaardig',
  description: 'Leerling kiest een te brede letter-range (bv. A–M i.p.v. C–E) en mist daardoor precisie.',
  typicalFamilies: ['STU-ALFABET']
}, {
  id: 'stu.alfabet-tweede-letter-overgeslagen',
  label: 'Tweede letter niet gebruikt',
  module: 'Studievaardig',
  description: 'Bij woorden met dezelfde beginletter kijkt leerling niet door naar de tweede of derde letter om de volgorde te bepalen.',
  typicalFamilies: ['STU-ALFABET', 'STU-WOORDENBOEK']
}, {
  id: 'stu.alfabet-verkeerde-beginletter',
  label: 'Woord onder verkeerde beginletter',
  module: 'Studievaardig',
  description: 'Leerling plaatst een woord onder een letter die niet de beginletter is (bv. door verwarring met klank vs. spelling).',
  typicalFamilies: ['STU-ALFABET', 'STU-WOORDENBOEK']
}, {
  id: 'stu.alfabet-z-speciale-positie',
  label: 'Z als speciale positie',
  module: 'Studievaardig',
  description: 'Leerling denkt dat Z (of een andere randletter) een uitzonderlijke positie heeft binnen het alfabet.',
  typicalFamilies: ['STU-ALFABET']
}, {
  id: 'stu.alfabet-verkeerde-middenletter',
  label: 'Letter bij verkeerde middenletter',
  module: 'Studievaardig',
  description: 'Leerling weet de globale richting (begin/eind) maar plaatst de letter bij de verkeerde middenletter.',
  typicalFamilies: ['STU-ALFABET']
}, {
  id: 'stu.alfabet-positie-niet-relevant',
  label: 'Positie binnen alfabet doet er niet toe',
  module: 'Studievaardig',
  description: 'Leerling denkt dat de exacte positie binnen het alfabet niet uitmaakt voor ordening of opzoeken.',
  typicalFamilies: ['STU-ALFABET']
},
// ───────────────────────────────────────────────────────────
// STU-COMBINEER — meerdere bronnen combineren
// ───────────────────────────────────────────────────────────
{
  id: 'stu.zoek-op-opdracht',
  label: 'Zoekt op de opdracht i.p.v. het onderwerp',
  module: 'Studievaardig',
  description: 'Leerling typt de letterlijke vraag in een zoekmachine i.p.v. een kernwoord uit het onderwerp.',
  typicalFamilies: ['STU-COMBINEER', 'STU-INTERNET']
}, {
  id: 'stu.zoekterm-te-breed',
  label: 'Zoekterm te breed',
  module: 'Studievaardig',
  description: 'Leerling gebruikt één algemeen woord (bv. "dieren") i.p.v. een specifieke samengestelde zoekterm.',
  typicalFamilies: ['STU-COMBINEER', 'STU-INTERNET']
}, {
  id: 'stu.weer-vs-klimaat',
  label: 'Weer en klimaat verward',
  module: 'Studievaardig',
  description: 'Leerling gebruikt "weer" (dag-fluctuatie) en "klimaat" (gemiddelde over jaren) door elkaar bij het selecteren van bronnen.',
  typicalFamilies: ['STU-COMBINEER']
}, {
  id: 'stu.conclusie-buiten-bron',
  label: 'Conclusie buiten bron',
  module: 'Studievaardig',
  description: 'Leerling trekt een conclusie die niet door de gegeven bronnen wordt ondersteund (verzint of voegt eigen kennis toe).',
  typicalFamilies: ['STU-COMBINEER']
}, {
  id: 'stu.bron-negeren',
  label: 'Bron genegeerd',
  module: 'Studievaardig',
  description: 'Leerling negeert relevante cijfers of citaten in de aangeboden bronnen.',
  typicalFamilies: ['STU-COMBINEER']
}, {
  id: 'stu.bronnen-vergelijken-ipv-combineren',
  label: 'Bronnen vergeleken i.p.v. gecombineerd',
  module: 'Studievaardig',
  description: 'Leerling zet bronnen naast elkaar (vergelijken) i.p.v. ze samen te gebruiken om één conclusie te bouwen.',
  typicalFamilies: ['STU-COMBINEER']
}, {
  id: 'stu.een-bron-volstaat',
  label: 'Eén bron volstaat',
  module: 'Studievaardig',
  description: 'Leerling denkt dat één bron genoeg is voor een onderbouwde conclusie, terwijl de opdracht expliciet om combineren vraagt.',
  typicalFamilies: ['STU-COMBINEER']
}, {
  id: 'stu.bron-doelgroep-verwart',
  label: 'Doelgroep van bron verward',
  module: 'Studievaardig',
  description: 'Leerling past informatie uit een bron toe op de verkeerde doelgroep (bv. volwassen-richtlijnen op kinderen).',
  typicalFamilies: ['STU-COMBINEER']
}, {
  id: 'stu.anekdote-als-bewijs',
  label: 'Anekdote als bewijs',
  module: 'Studievaardig',
  description: 'Leerling beschouwt persoonlijke verhalen of vrienden-uitspraken als gelijkwaardig bewijs aan systematische bronnen.',
  typicalFamilies: ['STU-COMBINEER']
}, {
  id: 'stu.commercieel-als-onafhankelijk',
  label: 'Commerciële bron als onafhankelijk',
  module: 'Studievaardig',
  description: 'Leerling onderscheidt commerciële (reclame, fabrikant) en onafhankelijke bronnen niet.',
  typicalFamilies: ['STU-COMBINEER', 'STU-INTERNET']
},
// ───────────────────────────────────────────────────────────
// STU-INHOUDSOPGAVE — inhoudsopgave gebruiken
// ───────────────────────────────────────────────────────────
{
  id: 'stu.inhoud-woordenlijst-verward',
  label: 'Inhoudsopgave en woordenlijst verward',
  module: 'Studievaardig',
  description: 'Leerling verwart een inhoudsopgave (hoofdstukken) met een woordenlijst (begrippen).',
  typicalFamilies: ['STU-INHOUDSOPGAVE']
}, {
  id: 'stu.inhoud-auteursinfo-verwacht',
  label: 'Auteursinfo in inhoudsopgave verwacht',
  module: 'Studievaardig',
  description: 'Leerling denkt dat schrijver- of uitgever-informatie in de inhoudsopgave staat.',
  typicalFamilies: ['STU-INHOUDSOPGAVE']
}, {
  id: 'stu.inhoud-flaptekst-verward',
  label: 'Inhoudsopgave en flaptekst verward',
  module: 'Studievaardig',
  description: 'Leerling verwart een inhoudsopgave (structuur) met een flaptekst (samenvatting).',
  typicalFamilies: ['STU-INHOUDSOPGAVE']
}, {
  id: 'stu.inhoud-verkeerd-hoofdstuk',
  label: 'Verkeerd hoofdstuk gekozen',
  module: 'Studievaardig',
  description: 'Leerling kiest het paginanummer van een ander hoofdstuk dan gevraagd.',
  typicalFamilies: ['STU-INHOUDSOPGAVE']
}, {
  id: 'stu.inhoud-aangrenzend-hoofdstuk',
  label: 'Verkeerd hoofdstuk gekozen (variant)',
  module: 'Studievaardig',
  description: 'Tweede variant van "verkeerd hoofdstuk": leerling kiest aangrenzend hoofdstuk i.p.v. het gevraagde.',
  typicalFamilies: ['STU-INHOUDSOPGAVE']
}, {
  id: 'stu.inhoud-paginanummer-verzonnen',
  label: 'Paginanummer verzonnen',
  module: 'Studievaardig',
  description: 'Leerling verzint een paginanummer i.p.v. de inhoudsopgave te raadplegen.',
  typicalFamilies: ['STU-INHOUDSOPGAVE']
}, {
  id: 'stu.inhoud-startpagina-als-lengte',
  label: 'Startpagina als hoofdstuklengte',
  module: 'Studievaardig',
  description: 'Leerling geeft de startpagina van een hoofdstuk als antwoord op "hoe lang is dit hoofdstuk?".',
  typicalFamilies: ['STU-INHOUDSOPGAVE']
}, {
  id: 'stu.inhoud-volgende-start-als-lengte',
  label: 'Volgende startpagina als hoofdstuklengte',
  module: 'Studievaardig',
  description: 'Leerling geeft de startpagina van het volgende hoofdstuk i.p.v. te subtraheren om de lengte te krijgen.',
  typicalFamilies: ['STU-INHOUDSOPGAVE']
}, {
  id: 'stu.inhoud-off-by-one',
  label: 'Off-by-one bij pagina-telling',
  module: 'Studievaardig',
  description: 'Leerling maakt een 1-pagina afwijking bij het berekenen van hoofdstuklengte uit startpaginas.',
  typicalFamilies: ['STU-INHOUDSOPGAVE']
}, {
  id: 'stu.inhoud-register-verward',
  label: 'Inhoudsopgave en register verward',
  module: 'Studievaardig',
  description: 'Leerling verwart de inhoudsopgave (voorin, hoofdstuk-volgorde) met het register (achterin, alfabetisch).',
  typicalFamilies: ['STU-INHOUDSOPGAVE']
}, {
  id: 'stu.inhoud-midden-verwacht',
  label: 'Inhoudsopgave in midden verwacht',
  module: 'Studievaardig',
  description: 'Leerling denkt dat de inhoudsopgave in het midden van het boek staat i.p.v. voorin.',
  typicalFamilies: ['STU-INHOUDSOPGAVE']
}, {
  id: 'stu.inhoud-flaptekst-geconsulteerd',
  label: 'Inhoudsopgave en flaptekst verward (consultatie)',
  module: 'Studievaardig',
  description: 'Leerling kijkt op de flaptekst om inhoudsopgave-informatie te vinden.',
  typicalFamilies: ['STU-INHOUDSOPGAVE']
}, {
  id: 'stu.inhoud-hele-boek-doorlezen',
  label: 'Hele boek doorlezen',
  module: 'Studievaardig',
  description: 'Leerling leest het hele boek door om een hoofdstuk te vinden i.p.v. de inhoudsopgave te gebruiken.',
  typicalFamilies: ['STU-INHOUDSOPGAVE']
}, {
  id: 'stu.inhoud-willekeurig-bladeren',
  label: 'Willekeurig bladeren',
  module: 'Studievaardig',
  description: 'Leerling bladert willekeurig door het boek i.p.v. de inhoudsopgave te gebruiken als index.',
  typicalFamilies: ['STU-INHOUDSOPGAVE']
}, {
  id: 'stu.inhoud-flaptekst-als-eerste',
  label: 'Flaptekst als eerste oriëntatie',
  module: 'Studievaardig',
  description: 'Leerling begint bij de flaptekst voor structuur-info terwijl de inhoudsopgave die rol vervult.',
  typicalFamilies: ['STU-INHOUDSOPGAVE']
},
// ───────────────────────────────────────────────────────────
// STU-WOORDENBOEK — woordenboek gebruiken
// ───────────────────────────────────────────────────────────
{
  id: 'stu.woordenboek-afkorting-verward',
  label: 'Afkorting verward',
  module: 'Studievaardig',
  description: 'Leerling verwart de betekenis van een afkorting in het woordenboek.',
  typicalFamilies: ['STU-WOORDENBOEK']
}, {
  id: 'stu.woordenboek-positie-verkeerd-geschat',
  label: 'Positie verkeerd geschat',
  module: 'Studievaardig',
  description: 'Leerling schat de positie van een woord in het woordenboek verkeerd in.',
  typicalFamilies: ['STU-WOORDENBOEK']
},
// ── STU-WOORDENBOEK ───────────────────────────────────────────────────────
{
  id: 'stu.woordenboek-afkorting-verwarren',
  label: 'Woordenboek-afkorting verward',
  module: 'Studievaardigheden',
  description: 'Leerling verwart afkortingen in een woordenboeklemma (bijv. zn. / ww. / bn. / bw.) bij het bepalen van de woordsoort. Cross-module link met taa.soort-*.',
  typicalFamilies: ['STU-WOORDENBOEK']
}, {
  id: 'stu.woordenboek-positie-schatten',
  label: 'Woordenboek-positie verkeerd geschat',
  module: 'Studievaardigheden',
  description: 'Leerling schat de alfabetische positie van een woord in het woordenboek verkeerd in (bijv. zoekt "muis" in het achterste deel i.p.v. middenin).',
  typicalFamilies: ['STU-WOORDENBOEK']
},
// ───────────────────────────────────────────────────────────
// STU-BIBLIOTHEEK — bibliotheek-conventies
// ───────────────────────────────────────────────────────────
{
  id: 'stu.bibliotheek-fictie-nonfictie-verward',
  label: 'Fictie en non-fictie verward',
  module: 'Studievaardig',
  description: 'Leerling verwart fictie met non-fictie.',
  typicalFamilies: ['STU-BIBLIOTHEEK']
}, {
  id: 'stu.bibliotheek-stripboek-als-informatief',
  label: 'Stripboek als informatief',
  module: 'Studievaardig',
  description: 'Leerling denkt dat een stripboek altijd een informatief boek is.',
  typicalFamilies: ['STU-BIBLIOTHEEK']
}, {
  id: 'stu.bibliotheek-poezie-als-informatief',
  label: 'Poëzie als informatief',
  module: 'Studievaardig',
  description: 'Leerling denkt dat poëzie informatief is.',
  typicalFamilies: ['STU-BIBLIOTHEEK']
}, {
  id: 'stu.bibliotheek-nur-als-paginas',
  label: 'NUR als paginas',
  module: 'Studievaardig',
  description: "Leerling denkt dat de NUR-code het aantal pagina's is.",
  typicalFamilies: ['STU-BIBLIOTHEEK']
}, {
  id: 'stu.bibliotheek-nur-als-jaar',
  label: 'NUR als jaar',
  module: 'Studievaardig',
  description: 'Leerling denkt dat de NUR-code het jaar van uitgave is.',
  typicalFamilies: ['STU-BIBLIOTHEEK']
}, {
  id: 'stu.bibliotheek-nur-als-prijs',
  label: 'NUR als prijs',
  module: 'Studievaardig',
  description: 'Leerling denkt dat de NUR-code de prijs is.',
  typicalFamilies: ['STU-BIBLIOTHEEK']
}, {
  id: 'stu.bibliotheek-zoeken-zonder-catalogus',
  label: 'Zoeken zonder catalogus',
  module: 'Studievaardig',
  description: 'Leerling wil alle schappen langslopen in plaats van de catalogus te gebruiken.',
  typicalFamilies: ['STU-BIBLIOTHEEK']
}, {
  id: 'stu.bibliotheek-vriend-als-catalogus',
  label: 'Vriend als catalogus',
  module: 'Studievaardig',
  description: 'Leerling vraagt een vriend in plaats van de catalogus te gebruiken.',
  typicalFamilies: ['STU-BIBLIOTHEEK']
}, {
  id: 'stu.bibliotheek-internet-als-catalogus',
  label: 'Internet als catalogus',
  module: 'Studievaardig',
  description: 'Leerling zoekt op internet in plaats van in de bibliotheekcatalogus.',
  typicalFamilies: ['STU-BIBLIOTHEEK']
}];